export default {
      id: "ic_lmt_pin-usage",
      viewBox: "0 0 17 14",
      url: "/" + "images/icons.3.109.2.svg#ic_lmt_pin-usage",
      toString: function () {
        return this.url;
      }
    }